import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  CircularProgress,
  Dialog,
} from '@mui/material';
import axios from 'axios';
import Logger from './utils/logger';
import { auth } from './firebase';
import { onAuthStateChanged, signOut, signInAnonymously } from 'firebase/auth';
import Auth from './components/Auth';
import WorksheetGenerator from './components/WorksheetGenerator';

// Debug environment variables
console.log('Environment variables:', {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV
});

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
console.log('Using API URL:', API_BASE_URL);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAuthDialog, setShowAuthDialog] = useState(false);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
      Logger.info('Auth state changed', { user: user ? user.email : 'anonymous' });
    });

    // Sign in anonymously by default
    if (!auth.currentUser) {
      signInAnonymously(auth)
        .then(() => {
          Logger.info('Signed in anonymously');
        })
        .catch((error) => {
          Logger.error('Anonymous sign-in error:', error);
        });
    }

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      // Sign in anonymously after signing out
      await signInAnonymously(auth);
      Logger.info('User signed out and continued as guest');
    } catch (error) {
      Logger.error('Error during sign out:', error);
    }
  };

  if (loading) {
      return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        {/* Header with Sign In/Out Button */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
            Create Worksheets For Your Students
                      </Typography>
                    <Button
                      variant="outlined"
            onClick={() => user?.isAnonymous ? setShowAuthDialog(true) : handleSignOut()}
                      sx={{ color: 'black', borderColor: 'black', '&:hover': { borderColor: '#333', color: '#333' } }}
                    >
            {user?.isAnonymous ? 'Sign In' : 'Sign Out'}
                    </Button>
                  </Box>

        {/* Auth Dialog */}
        <Dialog 
          open={showAuthDialog} 
          onClose={() => setShowAuthDialog(false)}
          maxWidth="sm"
                  fullWidth
        >
          <Auth onClose={() => setShowAuthDialog(false)} />
        </Dialog>

        {/* Main Content */}
        <Box sx={{ flexGrow: 1 }}>
          <WorksheetGenerator 
            user={user}
            onAuthRequired={() => setShowAuthDialog(true)}
          />
                    </Box>
              </Box>
    </Container>
  );
}

export default App; 